import React, { PropsWithChildren } from 'react';
import TabPanel, {TabPanelRef} from "devextreme-react/tab-panel";

const FormListBaseTab = React.forwardRef<TabPanelRef, PropsWithChildren & { visible?: boolean, className?: string }>(({ children, visible, className }, ref): any => {

  if (!ref || !children) return <></>;
  return (
    <TabPanel className={className} style={{ flex: 1 }} id={"tabPanel"} scrollByContent={true} showNavButtons={true} ref={ref} visible={visible !== undefined ? visible : true}>
      {children}
    </TabPanel>
  );
});
export default FormListBaseTab;